import React from 'react';
import { Redirect , Route } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route 
    { ...rest } render={props =>  sessionStorage.getItem("access_token") ? (<Component { ...props} />) : (<Redirect to = {{ pathname: '/404' ,state : {from : props.location}}}/>)}
    />
)

export default PrivateRoute;